import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultBaseInteractiveRenderContribution } from "./contributions";

import { SymbolRenderContribution } from "./contributions/constants";

import { GraphicRender, SymbolRender } from "./symbol";

import { DefaultCanvasSymbolRender } from "./symbol-render";

const loadedSymbolModuleContexts = new WeakSet;

export function bindSymbolRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedSymbolModuleContexts, bind) || (bind(DefaultCanvasSymbolRender).toDynamicValue((({container: container}) => new DefaultCanvasSymbolRender(createContributionProvider(SymbolRenderContribution, container)))).inSingletonScope(), 
    bind(SymbolRender).toService(DefaultCanvasSymbolRender), bind(GraphicRender).toService(SymbolRender), 
    bind(SymbolRenderContribution).toService(DefaultBaseInteractiveRenderContribution), 
    bindContributionProvider(bind, SymbolRenderContribution));
}

export const symbolModule = bindSymbolRenderModule;
//# sourceMappingURL=symbol-module.js.map
